var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro-card"},[_c('tilt-card',{attrs:{"img":_vm.img,"copy":_vm.copy},on:{"clicked":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }